import * as Util from "../common/util";
import * as Data from "../interfaces/data";

export interface IUser {
    ID: number;
    UserName: string;
    Email: string;
}

export interface ITemplateAccessRoleTemplate {
    ID: number;
    TemplateID: number;
    TemplateAccessRoleID: number;
    TemplateName: number;
    TemplateAccessRoleName: string;
    IsActive: boolean;
}

export interface ITemplateAccessRoleUser {
    ID: number;
    UserID: number;
    TemplateAccessRoleID: number;
    UserName: number;
    IsActive: boolean;
}

export interface ITemplateAccessRole {
    ID: number;
    Name: string;
    IsActive: boolean;
    UsersInRole: ITemplateAccessRoleUser[];
    TemplatesInRole: ITemplateAccessRoleTemplate[];
}
export interface ITemplateAccessRoleUserObservable {
    ID: KnockoutObservable<number>;
    UserID: KnockoutObservable<number>;
    TemplateAccessRoleID: KnockoutObservable<number>;
    UserName: KnockoutObservable<number>;
    IsActive: KnockoutObservable<boolean>;
}

export interface ITemplateAccessRoleTemplateObservable {
    ID: KnockoutObservable<number>;
    TemplateID: KnockoutObservable<number>;
    TemplateAccessRoleID: KnockoutObservable<number>;
    TemplateAccessRoleName: KnockoutObservable<string>;
    TemplateName: KnockoutObservable<number>;
    IsActive: KnockoutObservable<boolean>;
}

export function GetAll(): JQueryDeferred<Data.IResponse<ITemplateAccessRole[]>> {
    return Util.callWebService("/api/TemplateAccessRole/GetAll", "GET");
}

export function Save(role: ITemplateAccessRole): JQueryDeferred<Data.IResponse<ITemplateAccessRole>> {
    return Util.callWebService("/api/TemplateAccessRole/Save", "POST", role);
}

export function GetByID(id: number): JQueryDeferred<Data.IResponse<ITemplateAccessRole>> {
    return Util.callWebService(`/api/TemplateAccessRole/GetByID/${id}`, "GET");
}

export function Delete(id: number): JQueryDeferred<Data.IResponse<string>> {
    return Util.callWebService(`/api/TemplateAccessRole/Delete/${id}`, "POST");
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--7!./src/script/data/templateAccessRoleData.ts